import { Grid } from '@mui/material'
import React from 'react'
import Tag from './../../components/Tag/Tag'
import TimelineComponent from './../../components/Timeline/TimelineComponent'
import WorkHistoryIcon from '@mui/icons-material/WorkHistory'
import SchoolIcon from '@mui/icons-material/School'
import '../../components//Timeline/Timeline.css'
import TimelineItem from '@mui/lab/TimelineItem'
import TimelineContent from '@mui/lab/TimelineContent'
import CustomTimelineSeperator from './../../components/Timeline/CustomTimelineSeperator'
import CustomTimelineLast from './../../components/Timeline/CustomeTimelineLast'
import { WorkHistory } from './../../utils/WorkHistory'
import './Resume.css'
import { EduHistory } from './../../utils/EduHistory'

export const CustomTimelineItem = ({ title, date, description }) => {
  return (
    <TimelineItem className='timeline-line'>
      <CustomTimelineSeperator />
      <TimelineContent>
        <div className='profile-data resume-info'>
          <h3>{title}</h3>
          <span>{date}</span>
          <p>{description}</p>
        </div>
      </TimelineContent>
    </TimelineItem>
  )
}
export const CustomTimelineItemLast = () => {
  return (
    <TimelineItem>
      <CustomTimelineLast />
      <TimelineContent>
        <div className='profile-data'></div>
      </TimelineContent>
    </TimelineItem>
  )
}
function Resume () {
  return (
    <div>
      <Tag tagName='Resume' />
      <Grid container className='resume-box'>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <TimelineComponent title='Working History' icon={<WorkHistoryIcon />}>
            {WorkHistory.map(data => {
              return (
                <CustomTimelineItem
                  key={data.id}
                  title={data.position}
                  date={data.date}
                  description={data.description}
                />
              )
            })}
            <CustomTimelineItemLast />
          </TimelineComponent>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <TimelineComponent title='Education History' icon={<SchoolIcon />}>
            {EduHistory.map(data => {
              return (
                <CustomTimelineItem
                  key={data.id}
                  title={data.school}
                  date={data.date}
                  description={data.description}
                />
              )
            })}
            <CustomTimelineItemLast />
          </TimelineComponent>
        </Grid>
      </Grid>
    </div>
  )
}

export default Resume
